export enum BusinessRole {
    HQ = "HQ",
    MS = "MS",
    DP = "DP",
}
